import React from 'react';

/**
 * 회사 연혁 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const CompanyHistoryProperties = [
  {
    group: '기본 설정',
    properties: [
      {
        name: 'title',
        label: '제목',
        control: 'TextField',
        defaultValue: '회사 연혁'
      },
      {
        name: 'subtitle',
        label: '부제목',
        control: 'TextField',
        defaultValue: '저희 회사의 성장 과정을 소개합니다'
      },
      {
        name: 'timelineStyle',
        label: '타임라인 스타일',
        control: 'Select',
        options: [
          { value: 'vertical', label: '수직형' },
          { value: 'horizontal', label: '수평형' }
        ],
        defaultValue: 'vertical'
      },
      {
        name: 'animation',
        label: '애니메이션 사용',
        control: 'Checkbox',
        defaultValue: true
      }
    ]
  },
  {
    group: '색상 설정',
    properties: [
      {
        name: 'colorScheme.primary',
        label: '주 색상',
        control: 'ColorPicker',
        defaultValue: '#3498db'
      },
      {
        name: 'colorScheme.secondary',
        label: '보조 색상',
        control: 'ColorPicker',
        defaultValue: '#f1c40f'
      },
      {
        name: 'colorScheme.background',
        label: '배경 색상',
        control: 'ColorPicker',
        defaultValue: '#ffffff'
      },
      {
        name: 'colorScheme.text',
        label: '텍스트 색상',
        control: 'ColorPicker',
        defaultValue: '#333333'
      }
    ]
  },
  {
    group: '이미지 설정',
    properties: [
      {
        name: 'imageWidth',
        label: '이미지 너비',
        control: 'NumberField',
        min: 50,
        max: 300,
        step: 10,
        defaultValue: 150
      },
      {
        name: 'imageHeight',
        label: '이미지 높이',
        control: 'NumberField',
        min: 50,
        max: 300,
        step: 10,
        defaultValue: 150
      },
      {
        name: 'imageSize',
        label: '이미지 크기(정사각형)',
        control: 'NumberField',
        hint: '정사각형 이미지를 위한 간편 설정 (width, height 모두 적용)',
        min: 50,
        max: 300,
        step: 10
      }
    ]
  },
  {
    group: '스타일',
    properties: [
      {
        name: 'style.padding',
        label: '여백',
        control: 'TextField',
        defaultValue: '40px 20px'
      },
      {
        name: 'style.maxWidth',
        label: '최대 너비',
        control: 'TextField',
        defaultValue: '1200px'
      },
      {
        name: 'style.margin',
        label: '마진',
        control: 'TextField',
        defaultValue: '0 auto'
      },
      {
        name: 'style.fontFamily',
        label: '글꼴',
        control: 'TextField',
        defaultValue: 'Noto Sans KR, sans-serif'
      }
    ]
  },
  {
    group: '연혁 항목',
    properties: [
      {
        name: 'historyItems',
        label: '연혁 항목',
        control: 'ItemList',
        itemFields: [
          { name: 'year', label: '연도', control: 'TextField' },
          { name: 'title', label: '제목', control: 'TextField' },
          { name: 'description', label: '설명', control: 'TextArea' },
          { name: 'image', label: '이미지 URL', control: 'TextField' }
        ],
        defaultValue: []
      }
    ]
  }
];

export default CompanyHistoryProperties; 